<script setup>
import { defineProps } from 'vue';
import { Star, Users, Heart, ArrowRight } from 'lucide-vue-next';
import { useThemeStore } from '../../stores/themeStore';
import PopularCoursesSection from '@/website/components/PopularCoursesSection.vue'
import pexel from '../../assets/pexel.jpg'
import carousel1 from '../../assets/carousel1.jpg'
const themeStore = useThemeStore();

</script>

<template>
  <section class="py-16 px-4 md:px-8 lg:px-16 bg-gradient-to-br from-gray-50 to-gray-100">
    <div class="text-center mb-12">
      <h2 class="text-3xl md:text-4xl font-extrabold mb-4 text-gray-900">{{ themeStore.theme.PopularCoursesSection.title }}</h2>
      <p class="text-gray-700 max-w-2xl mx-auto text-lg leading-relaxed">
        {{ themeStore.theme.PopularCoursesSection.subtitle }}
           </p>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
      <div v-for="(course, index) in themeStore.theme.PopularCoursesSection.cards" :key="index"
        class="bg-white border border-gray-200 rounded-2xl shadow-xl overflow-hidden transform transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl cursor-pointer">
        <img :src="pexel" :alt="course.title" class="w-full h-48 object-cover" />
        <div class="p-6">
          <h3 class="text-xl font-bold mb-2 text-gray-900">{{ course.title }}</h3>
          <p class="text-gray-600 text-sm mb-4 line-clamp-3">{{ course.description }}</p>
          <div class="flex items-center gap-1 mb-3">
            <Star v-for="n in course.rating" :key="n" :size="18" class="text-yellow-400 fill-yellow-400" />
            <Star v-for="n in (5 - course.rating)" :key="n + 5" :size="18" class="text-gray-300" />
            <span class="text-sm text-gray-500 ml-2">({{ course.rating }}/5)</span>
          </div>
          <div class="flex items-center justify-between text-sm text-gray-500 mb-4 border-b border-gray-100 pb-4">
            <div class="flex items-center gap-2">
              <Users :size="18" class="text-gray-400" /> <span class="text-gray-700">{{ course.students }} Students</span>
            </div>
            <div class="flex items-center gap-2">
              <Heart :size="18" class="text-gray-400" /> <span class="text-gray-700">{{ course.views }} Views</span>
            </div>
          </div>
          <div class="flex items-center justify-between pt-4">
            <div class="flex items-center gap-3">
              <img :src="carousel1" :alt="course.instructorName" class="w-9 h-9 rounded-full object-cover border-2 border-gray-100 shadow-sm" />
              <span class="font-semibold text-gray-800">{{ course.instructorName }}</span>
            </div>
            <span :class="['px-4 py-1 rounded-full text-sm font-bold text-white', course.price === 'Free' ? 'bg-[#28a745]' : 'bg-[#ffc107]']">
              {{ course.price }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center mt-12">
      <button class="bg-[#db2777] text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-[#be185d] transition-all duration-300 flex items-center gap-3 mx-auto shadow-lg hover:shadow-xl">
        View All Courses <ArrowRight :size="22" />
      </button>
    </div>
  </section>
</template>
